import React from "react";

const Contacts = () => {
  return (
    <div className="blog-container">
      <div className="card-about">
        <div className="card-about-title">
          <p>Contact</p>
          <h1>Social Media and My repositories and more..</h1>
        </div>
        <div className="card-about-contact">
          <div>
            <i>
              Send me invite link on your accounts.Publish oyur
              projects.Enjoys.Have a nice day..Click this social media icons
              plss
            </i>
            <div>
              <a
                href="https://www.w3schools.com"
                target="_blank"
                className="fab fa-skype"
              >
                {" "}
                Send Skype invite link
              </a>
            </div>
            <a
              href="https://www.linkedin.com/in/%C3%B6zhan-yildiz-bb9372172/"
              className="fab fa-linkedin"
              target="_blank"
            >
              {" "}
              Özhan YILDIZ
            </a>
            <div>
              <a
                href="https://github.com/lbeatu"
                className="fab fa-github"
                target="_blank"
              >
                {"  "}
                lbeatu-Repo
              </a>
            </div>
            <div>
              <a
                href="mailto:ozhan.yldz@gmail.com?subject=free chocolate"
                className="fab fa-usps"
                target="_blank"
              >
                {"  "}
                E-mail:ozhan.yldz@gmail.com
              </a>
            </div>
            <div>
              <button type="button">Download CV</button>
            </div>
            <i>
              Download Cv .pdf file <span>Last update:15.10.2019</span>
            </i>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contacts;
